import type {SketchParabolaObject} from '../sketch/SketchParabolaObject';
import {hasRuntimeFlag} from './hasRuntimeFlag';

/**
 * 判断对象是否为草图抛物线对象。
 * @param value 待判断对象。
 * @returns 当对象满足草图抛物线协议时返回 true。
 */
export function isSketchParabolaObject(value: unknown): value is SketchParabolaObject {
    // 基于运行时标记进行协议判断，避免对构造函数形成强耦合。
    return hasRuntimeFlag(value, 'isSketchParabolaObject');
}
